import React from 'react'

function ATSExecution() {
  return (
    <div className='ats-insert-ads'></div>
  )
}

export default ATSExecution
